module.exports = __webpack_public_path__ + "img/onlineDonation.9b134508.svg";